import React from 'react';

import { CreateCompanyClientContext } from './CreateCompanyClientContext';
import { EditCompanyClientContext } from './EditCompanyClientContext';

const useCreateCompanyClientContext = () => React.useContext(CreateCompanyClientContext);
const useEditCompanyClientContext = () => React.useContext(EditCompanyClientContext);

export { useCreateCompanyClientContext, useEditCompanyClientContext };
